import { DayNumber } from '@app/components/Calendars/components/DayNumber/DayNumber.main';

export { DayNumber };
